export default "__VITE_ASSET__cn642xXn__"